import {
  DECLARATIVE_TAGS,
  DECLARATIVE_TAGS_EN,
  DECLARATIVE_TAGS_AL,
  DECLARATIVE_TAGS_FR
} from '../../config'
import { transformToParams } from '../../modals/js/transformToParams'
import { buildParamsFromTags } from './buildParamsFromTags'
import {
  THANKS_MODAL_ERROR,
  THANKS_MODAL_ERROR_EN,
  THANKS_MODAL_ERROR_DE,
  THANKS_MODAL_ERROR_FR,
  THANKS_MODAL_SUCCESS,
  THANKS_MODAL_SUCCESS_EN,
  THANKS_MODAL_SUCCESS_DE,
  THANKS_MODAL_SUCCESS_FR
} from './customThanksModal'
import fetchJsonp from 'fetch-jsonp'

export function generateLead(event, { data, selectedPrefix }) {
  event.preventDefault()
  const $modalInEnglish = document.querySelector('.custom-budget--en')
  const $modalInDeu = document.querySelector('.custom-budget--de')
  const $modalInFr = document.querySelector('.custom-budget--fr')

  console.log(data)
  const handlerData = {
    ...data,
    prefix: selectedPrefix
  }

  const DEFAULT_TAGS = buildParamsFromTags({
    tags: $modalInEnglish
      ? DECLARATIVE_TAGS_EN
      : $modalInDeu
      ? DECLARATIVE_TAGS_AL
      : $modalInFr
      ? DECLARATIVE_TAGS_FR
      : DECLARATIVE_TAGS
  })

  const TAGS_FROM_USER_FIELDS = transformToParams(
    $modalInEnglish
      ? data
      : $modalInDeu
      ? data
      : $modalInFr
      ? data
      : handlerData
  )

  const TAGS_FORM_DFI = transformToParams(window.DFI.labels.EDeclaratives)
  const DYNAMIC_TAGS = transformToParams({
    origen_lead: window.originLeadValue,
    deduplicateLabel: window.deduplicateLabelValue,
    deduplicateWindow: window.deduplicateWindowValue,
    lead_generado: window.generateLeadTag,
    tipo_url: window.tipoUrlTag,
    fbp: window.DFI_client.fbp,
    fbc: window.DFI_client.fbc
  })
  const ID_LEAD = transformToParams({
    idlead: window.Piwik.getAsyncTracker().getVisitorId()
  })

  const URL = `${DEFAULT_TAGS}${TAGS_FROM_USER_FIELDS}${TAGS_FORM_DFI}${ID_LEAD}${DYNAMIC_TAGS}}`

  return fetchJsonp(URL, {
    timeout: 40000
  })
    .then((res) => res.json())
    .then(({ result }) => {
      setTimeout(() => {
        console.log(result)
        const $customBudget = document.querySelector('.custom-budget')
        const $customBudgetEn = document.querySelector('.custom-budget--en')
        const $customBudgetDe = document.querySelector('.custom-budget--de')
        const $customBudgetFr = document.querySelector('.custom-budget--fr')

        if (result === 'OK' && $customBudgetEn !== null) {
          $customBudgetEn.innerHTML = THANKS_MODAL_SUCCESS_EN({
            name: data.nombre,
            type: data['client-type']
          })
          return
        }
        if (result === 'OK' && $customBudgetDe !== null) {
          $customBudgetDe.innerHTML = THANKS_MODAL_SUCCESS_DE({
            name: data.nombre,
            type: data['client-type']
          })
          return
        }
        if (result === 'OK' && $customBudgetFr !== null) {
          $customBudgetFr.innerHTML = THANKS_MODAL_SUCCESS_FR({
            name: data.nombre,
            type: data['client-type']
          })
          return
        }
        if (
          result === 'OK' &&
          $customBudgetEn === null &&
          $customBudgetDe === null &&
          $customBudgetFr === null
        ) {
          $customBudget.innerHTML = THANKS_MODAL_SUCCESS({
            name: data.nombre,
            type: data['client-type']
          })
          return
        }

        if (
          result === 'KO' &&
          $customBudgetEn === null &&
          $customBudgetDe === null &&
          $customBudgetFr === null
        ) {
          $customBudget.innerHTML = THANKS_MODAL_ERROR
        }
        if (result === 'KO' && $customBudgetEn !== null) {
          $customBudget.innerHTML = THANKS_MODAL_ERROR_EN
        }
        if (result === 'KO' && $customBudgetDe !== null) {
          $customBudget.innerHTML = THANKS_MODAL_ERROR_DE
        }
        if (result === 'KO' && $customBudgetFr !== null) {
          $customBudget.innerHTML = THANKS_MODAL_ERROR_FR
        }
      }, 2000)
    })
    .catch((error) => {
      const $customBudget = document.querySelector('.custom-budget')
      $customBudget.innerHTML = THANKS_MODAL_ERROR
      console.error(error.message)
    })
}
